//scroll
jQuery(function ($) {
	var headerHight = 80;
	jQuery('a[href^="#"]:not(.non7scroll)').click(function () {
		var speed = 1000;
		var href = jQuery(this).attr("href");
		var target = jQuery(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - headerHight;
		jQuery('body,html').animate({
			scrollTop: position
		}, speed, 'swing');
		return false;
	});
});

//ページ内リンクでURLを変えたくない
$(document).ready(function () {
	$('a[href^="#"]').click(function () {
		var speed = 500; // スクロールスピード
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({ scrollTop: position }, speed, "swing");
		return false;
	});
});

//スムーススクロール
document.addEventListener('DOMContentLoaded', function () {
	const links = document.querySelectorAll('a[href^="#"]');

	links.forEach(link => {
		link.addEventListener('click', function (e) {
			e.preventDefault();

			const targetId = this.getAttribute('href').substring(1);
			const target = document.getElementById(targetId);

			if (target) {
				const offset = target.getBoundingClientRect().top;
				const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
				const targetOffsetTop = offset + scrollPosition;

				window.scrollTo({
					top: targetOffsetTop,
					behavior: 'smooth'
				});
			}
		});
	});
});